<mat-table [dataSource]="data">
  <ng-container [matColumnDef]="column" *ngFor="let column of columnsToDisplay">
    <mat-header-cell *matHeaderCellDef>{{ columnsNames[column] }}</mat-header-cell>
    <mat-cell *matCellDef="let element">{{ element[column] ? element[column] : "-" }} </mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="columnsToDisplay"></mat-header-row>
  <mat-row *matRowDef="let row; columns: columnsToDisplay"></mat-row>
</mat-table>
